import { Translation } from "./index";

const en: Translation = {
  components: {
    searchProduct: "Search product",
    withoutBarCode: "without bar code",
    stillHereModal: {
      title: "Are you still here?",
      closingIn: "If not, we will close in <0>{{count}} seconds.</0>",
      nextCustomer: "Next customer",
      stillHere: "Yes, I'm still here",
    },
    receipt: {
      vat: "VAT",
      deposit: "Container deposit",
      yourReceipt: "Your receipt",
      subtotal: "Subtotal",
    },
  },
  startPage: {
    title: "Scan & Pay",
    scanBarCode: "Scan the barcode or press start",
    version: "Version: {{version}}",
    pickupTitle: "What do you want to pick up later?",
    pickupSubtitle: "Press start to place an order",
  },
  mainPage: {
    pageTitle: "Scan your products",
    pickupPageTitle: "What do you want to pick up?",
    checkout: "Checkout",
    productSearch: "Product search",
    selectCategory: "Select category",
    yourReceipt: "Your receipt",
    emptyReceiptText: "Scan your products and discount vouchers",
    emptyPickupReceiptText: "Select the products you wish to order",
    foundProducts: "Found products",
    typeProduct: "Type product...",
    ageCheckModal: {
      title: "Are you {{ age }} years old or older?",
      message: "We only sell alcoholic products if you are over {{ age }} years old.",
      confirmText: "Yes, I am {{ age }} or older",
      cancelText: "No",
    },
    combiDeals: {
      title: "Take advantage of the combi-deal!",
      message: "Scan or choose one of the products below and pay only {{ price }}!",
      noPriceMessage: "Scan or choose one of the products below and save!",
      deal: "Combi-deal",
    },
    invalidQrScan: {
      title: "Invalid QR code",
      message: "The scanned QR code is not valid. Please try again or visit the reception.",
    },
    ageCheckValid: "{{ age }}+ products can now be added.",
    productNotFound: "Scanned article not found",
    productNotFoundDescription:
      "We do not recognize the scanned item, please try again or go to reception.",
    vouchers: {
      doYouHave: "Do you have a <0>discount voucher?</0>",
      scanForDiscount: "Scan the voucher for discount",
      notValidTitle: "This QR is invalid",
    },
    errors: {
      unknownErrorTitle: "Unknown problem occurred",
      unknownErrorDescription:
        "An unknown problem has occurred. Please try again and otherwise stop by reception.",
      notFoundTitle: "Scanned voucher not found",
      notFoundDescription:
        "We do not recognize the scanned voucher, please try again or stop by reception.",
      addEligibleProductDescription: "Add an eligible product to redeem this voucher",
    },
  },
  checkoutPage: {
    followTerminal: "Follow the payment on the payment terminal.",
  },
  verificationPage: {
    title: "To verify that you are {{ age }}+, please scan a QR code.",
    verifiedID:
      "Do you have a verified RestaurantID (identifiable by the golden tick) in the Valk Exclusive app? Then scan your RestaurantID.",
    or: "OR",
    getCodeAtReception: "Get a QR code from reception.",
  },
  successPage: {
    paid: "Paid!",
    digitalReceipt: "Digital receipt",
    review: "Review",
    tip: "Do you have any suggestions?",
    selectStars: "Select the number of stars",
    sendReview: "Send",
    thanks: "Thank you for your feedback!",
    scanQr: "Scan the QR-code or type your email address for a PDF of your receipt.",
    sendReceipt: "Send receipt",
    fillInEmailForReceipt:
      "Do you want to receive the receipt digitally? Enter your email address below.",
    emailError: "An error has occurred, please try again or go to the reception.",
    emailSent: "Sent",
    hasSentReceipt: "The email has been sent!",
  },
  errorScreen: {
    title: "Sorry, something went wrong. Try again!",
    subTitle: "If it goes wrong several times, go to the reception.",
    noInternetTitle: "No internet connection",
  },
  failedPayment: {
    title: "Payment failed!",
    backToReceipt: "Back to receipt",
    startOver: "Start over",
  },
  pickup: {
    timeSlotPage: {
      title: "Choose your pick-up time",
      otherOptions: "Other possibilities:",
      tomorrow: "Other possibilities:",
    },
    yourInfoPage: {
      yourInfo: "Your information",
      personalInfo: "Personal information",
      firstName: "First name",
      lastName: "Last name",
      emailAddress: "Email address",
      phoneNumber: "Phone number",
      emailDesc: "We will send the digital voucher to this e-mail address",
      phoneNumberDesc: "Should there be any questions about your order",
      pay: "Pay",
      chosenTimeSlot: "Your chosen pick-up time",
      errors: {
        firstName: "Please fill in your first name",
        lastName: "Please fill in your last name",
        emailAddress: "Please fill in a valid e-mail address",
        phoneNumber: "Please fill in a valid phone number",
      },
    },
    successPage: {
      thanks: "Thank you for your order!",
      emailConfirmation: "We will send the confirmation and receipt to <0>{{ email }}</0>",
    },
  },
  ui: {
    start: "Start",
    total: "Total",
    search: "Search",
    cancel: "Cancel",
    tryAgain: "Try again",
    yourEmail: "Your email address",
    close: "Close",
    no: "No",
    closeModal: "Close",
    back: "Back",
    continue: "Continue",
    from: "From",
  },
};

export default en;
